import React from 'react';
import './header.css'
import pic13 from '../../assets/pic13.png'
import logo from '../../assets/logo.png'
import pic14 from '../../assets/pic14.png'


const Header = ( { onMenuClick }) => {
    return ( 
        <header className='header'>
            <nav className='container-info-header'>
                <button className='button-notification'>
                    <img src={pic13} alt='pic'></img>
                </button>
                <article className='container-profile'>
                    
                    <figure className='container-img-profile'>
                        <h2 className='text-circle'>S</h2>
                    </figure>

                    <article className='container-text-profile'>
                        <h2 className='admintext'>Salma Yasser</h2>
                        <h3 className='adminemail'>Administrator</h3>
                    </article>
                </article>

            </nav>

            <img className='logo2' src={logo} alt="logo"></img>
                            <button className='burger-menu' onClick={onMenuClick}>
                      <img src={pic14} alt="menu" />
                </button>
        </header>
     );
}
 
export default Header;